import { API_ERROR_CODE_I18N_REASON_AUTH_SHARED } from "./error-code-i18n-reasons-auth-shared";
import { API_ERROR_CODE_I18N_REASON_BUSINESS_WORKFLOW } from "./error-code-i18n-reasons-business-workflow";
import { API_ERROR_CODE_I18N_REASON_ENVIRONMENT_IMAGE } from "./error-code-i18n-reasons-environment-image";
import { API_ERROR_CODE_I18N_REASON_PLATFORM_ENVIRONMENT } from "./error-code-i18n-reasons-platform-environment";
import { API_ERROR_CODE_I18N_REASON_PLATFORM_OPERATIONS } from "./error-code-i18n-reasons-platform-operations";
import { API_ERROR_CODE_I18N_REASON_PLATFORM_SHARED } from "./error-code-i18n-reasons-platform-shared";

export const API_ERROR_CODE_I18N_REASON_KEY_MAP: Record<string, string> = {
  ...API_ERROR_CODE_I18N_REASON_AUTH_SHARED,
  ...API_ERROR_CODE_I18N_REASON_BUSINESS_WORKFLOW,
  ...API_ERROR_CODE_I18N_REASON_ENVIRONMENT_IMAGE,
  ...API_ERROR_CODE_I18N_REASON_PLATFORM_ENVIRONMENT,
  ...API_ERROR_CODE_I18N_REASON_PLATFORM_OPERATIONS,
  ...API_ERROR_CODE_I18N_REASON_PLATFORM_SHARED,
};
